import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue";
const _hoisted_1 = { class: "blueStep2 col-12 mb-4" };
const _hoisted_2 = { class: "col-12 bg-white border rounded pt-3" };
const _hoisted_3 = { class: "row border-bottom" };
const _hoisted_4 = { class: "col-12" };
const _hoisted_5 = { class: "font7 mb-2" };
const _hoisted_6 = { class: "col-7 pr-0 custom-control custom-radio" };
const _hoisted_7 = ["checked", "id", "value", "onClick"];
const _hoisted_8 = ["for"];
const _hoisted_9 = { class: "font8-responsive" };
const _hoisted_10 = ["for"];
const _hoisted_11 = {
    key: 1,
    class: "badge badge-light-green p-y-1 p-x-2 font-weight-normal font8-responsive"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_blue_shipping_period_info = _resolveComponent("blue-shipping-period-info");
    const _component_formatted_price = _resolveComponent("formatted-price");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _cache[2] || (_cache[2] = _createStaticVNode("<div class=\"row\"><div class=\"col-12\"><div class=\"font7 mb-2\">Schritt 2 von 3</div></div><div class=\"col-12 pr-0\"><h2 class=\"h5 mb-3\">Wähle Deine Lieferart</h2></div></div>", 1)),
            _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                        _createVNode(_component_blue_shipping_period_info),
                        _cache[0] || (_cache[0] = _createElementVNode("span", { class: "font8-responsive fc-gray1" }, "* Versandkosten inkl. MwSt", -1))
                    ])
                ])
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.shipping_options, (shipping_option) => {
                return (_openBlock(), _createElementBlock("div", {
                    class: "row pt-3 pb-3 pl-4 mb-0 border-bottom",
                    key: `shipping_option_${shipping_option.id}`
                }, [
                    _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("input", {
                            type: "radio",
                            class: "custom-control-input",
                            name: "lieferart",
                            checked: _ctx.currentShippingOption && shipping_option.id === _ctx.currentShippingOption.id,
                            id: shipping_option.id,
                            value: shipping_option.id,
                            onClick: ($event) => (_ctx.selectShippingOption(shipping_option.id))
                        }, null, 8, _hoisted_7),
                        _createElementVNode("label", {
                            class: "custom-control-label green-radio",
                            style: { "width": "100%", "height": "100%", "cursor": "pointer" },
                            for: shipping_option.id
                        }, [
                            _createTextVNode(_toDisplayString(shipping_option.title) + " ", 1),
                            _cache[1] || (_cache[1] = _createElementVNode("br", null, null, -1)),
                            _createElementVNode("span", _hoisted_9, _toDisplayString(shipping_option.description), 1)
                        ], 8, _hoisted_8)
                    ]),
                    _createElementVNode("label", {
                        class: "col-5 text-right",
                        style: { "cursor": "pointer" },
                        for: shipping_option.id
                    }, [
                        (shipping_option.cost > 0)
                            ? (_openBlock(), _createBlock(_component_formatted_price, {
                                key: 0,
                                price: shipping_option.cost
                            }, null, 8, ["price"]))
                            : (_openBlock(), _createElementBlock("span", _hoisted_11, " Kostenlos "))
                    ], 8, _hoisted_10)
                ]));
            }), 128))
        ])
    ]));
}
